var _path, _path2, _path3, _g, _g2, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 301,
    viewBox: "0 0 350 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H340C345.523 0 350 4.47715 350 10V290C350 295.523 345.523 300 340 300H10C4.47715 300 0 295.523 0 290V10Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.186 71.6332C281.456 62.7069 273.042 55.1857 263.42 49.4946C247.441 40 229.409 34.287 211.162 31.126C153.423 21.1326 121.772 31.706 97.8995 48.8914C82.0887 60.3 77.1181 84.5556 72.4491 102.193C69.8275 112.094 67.4901 122.099 64.2305 131.814C59.1671 146.894 47.6657 159.074 43.8319 174.624C39.7719 191.032 40.0909 208.316 45.7111 224.336C56.8181 255.98 75.6913 274.32 119 280.41C142.2 283.681 160.847 274.094 180.097 262.558C191.964 255.447 204.266 249.038 217.884 246.138C232.268 243.081 247.064 242.658 261.489 239.816C293.754 233.465 304.107 202.928 308.3 174.003C313.375 138.983 310.197 100.709 288.186 71.6332Z",
    fill: "#92E3A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M288.186 71.6332C281.456 62.7069 273.042 55.1857 263.42 49.4946C247.441 40 229.409 34.287 211.162 31.126C153.423 21.1326 121.772 31.706 97.8995 48.8914C82.0887 60.3 77.1181 84.5556 72.4491 102.193C69.8275 112.094 67.4901 122.099 64.2305 131.814C59.1671 146.894 47.6657 159.074 43.8319 174.624C39.7719 191.032 40.0909 208.316 45.7111 224.336C56.8181 255.98 75.6913 274.32 119 280.41C142.2 283.681 160.847 274.094 180.097 262.558C191.964 255.447 204.266 249.038 217.884 246.138C232.268 243.081 247.064 242.658 261.489 239.816C293.754 233.465 304.107 202.928 308.3 174.003C313.375 138.983 310.197 100.709 288.186 71.6332Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.973 45.2838H198.333L194.406 54.6972H308.973V45.2838Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 54.6972H198.333L194.406 64.1164H308.973V54.6972Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 64.1164H198.333L194.406 73.5298H308.973V64.1164Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 73.5298H198.333L194.406 82.949H308.973V73.5298Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 82.949H198.333L194.406 92.3624H308.973V82.949Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 92.3624H198.333L194.406 101.782H308.973V92.3624Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 101.782H198.333L194.406 111.195H308.973V101.782Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 111.195H198.333L194.406 120.614H308.973V111.195Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 120.614H198.333L194.406 130.028H308.973V120.614Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 130.028H198.333L194.406 139.447H308.973V130.028Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 139.447H198.333L194.406 148.86H308.973V139.447Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 148.86H198.333L194.406 158.279H308.973V148.86Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 158.279H198.333L194.406 167.693H308.973V158.279Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 167.693H198.333L194.406 177.112H308.973V167.693Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 177.112H198.333L194.406 186.525H308.973V177.112Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.973 186.525H198.333L194.406 195.945H308.973V186.525Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.322 42.146H193.229V199.082H311.322V42.146Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3118 255.685H53.6282V276.628H93.3118V255.685Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6889 263.706H70.2451V266.826H76.6889V263.706Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3417 228.465H51.5923V282.051H95.3417V228.465Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3118 231.18H53.6282V252.123H93.3118V231.18Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6889 239.201H70.2451V242.321H76.6889V239.201Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8198 225.072H62.2178V228.465H77.8198V225.072Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6976 214.563H67.9832V225.078H70.6976V214.563Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5852 190.139H54.417V214.557H83.5852V190.139Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.562 256.682V211.906C257.563 211.061 257.397 210.223 257.073 209.442C256.75 208.66 256.276 207.95 255.678 207.352C255.08 206.754 254.37 206.28 253.589 205.957C252.807 205.633 251.97 205.467 251.124 205.468H192.3V257.129",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.793 205.468H132.874C132.028 205.468 131.192 205.635 130.411 205.958C129.63 206.282 128.921 206.756 128.323 207.354C127.726 207.952 127.252 208.662 126.929 209.443C126.606 210.224 126.441 211.061 126.441 211.906V256.682",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.374 260.98V276.06H192.329V256.682H259.093C259.657 256.681 260.215 256.792 260.736 257.008C261.257 257.224 261.73 257.541 262.128 257.94C262.526 258.34 262.84 258.814 263.054 259.336C263.268 259.857 263.377 260.416 263.374 260.98Z",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.869 256.682H124.904C124.343 256.682 123.786 256.793 123.267 257.008C122.748 257.223 122.277 257.539 121.88 257.936C121.483 258.334 121.168 258.806 120.954 259.325C120.739 259.844 120.629 260.401 120.63 260.963V276.043H192.869",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63 282.347V276.019H263.495V282.347",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.441 230.988C126.038 230.569 125.555 230.235 125.02 230.006C124.484 229.778 123.909 229.66 123.327 229.66H110.387C109.821 229.659 109.26 229.77 108.736 229.986C108.213 230.203 107.737 230.52 107.336 230.92C106.935 231.32 106.617 231.796 106.4 232.319C106.183 232.842 106.072 233.403 106.072 233.969V282.04",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.429 281.727V233.969C276.429 232.826 275.975 231.73 275.167 230.922C274.359 230.114 273.263 229.66 272.12 229.66H259.18C258.625 229.658 258.075 229.766 257.562 229.979",
    stroke: "black",
    strokeWidth: 0.58,
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.307 41.1948V180.975C286.307 182.667 285.635 184.29 284.438 185.486C283.242 186.683 281.619 187.355 279.927 187.355H78.0868C76.3947 187.355 74.7719 186.683 73.5754 185.486C72.379 184.29 71.7068 182.667 71.7068 180.975V41.1948C71.7068 39.6566 72.3179 38.1813 73.4056 37.0936C74.4933 36.0059 75.9685 35.3948 77.5068 35.3948H280.507C282.045 35.3948 283.52 36.0059 284.608 37.0936C285.696 38.1813 286.307 39.6566 286.307 41.1948Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M286.307 41.1948V53.2588H71.7068V41.1948C71.7068 39.6566 72.3179 38.1813 73.4056 37.0936C74.4933 36.0059 75.9685 35.3948 77.5068 35.3948H280.507C282.045 35.3948 283.52 36.0059 284.608 37.0936C285.696 38.1813 286.307 39.6566 286.307 41.1948Z",
    fill: "#C9C9C9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.013 50.9214H95.5331C95.0172 50.9199 94.523 50.7139 94.1588 50.3486C93.7946 49.9833 93.5901 49.4885 93.5901 48.9726C93.5901 48.4568 93.7946 47.9619 94.1588 47.5966C94.523 47.2313 95.0172 47.0253 95.5331 47.0238H210.013C210.53 47.0238 211.026 47.2291 211.391 47.5946C211.757 47.9601 211.962 48.4558 211.962 48.9726C211.962 49.4895 211.757 49.9851 211.391 50.3506C211.026 50.7161 210.53 50.9214 210.013 50.9214Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.432 47.4124H282.833",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M275.432 48.9726H282.833",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.432 50.5328H282.833",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M286.307 41.1948V44.6748H71.7068V41.1948C71.7068 39.6566 72.3179 38.1813 73.4056 37.0936C74.4933 36.0059 75.9685 35.3948 77.5068 35.3948H280.507C282.045 35.3948 283.52 36.0059 284.608 37.0936C285.696 38.1813 286.307 39.6566 286.307 41.1948Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.928 40.2262C264.935 39.8735 264.837 39.5268 264.645 39.2303C264.454 38.9337 264.179 38.7008 263.855 38.5613C263.531 38.4218 263.173 38.382 262.827 38.447C262.48 38.5119 262.16 38.6787 261.909 38.9261C261.657 39.1734 261.485 39.4901 261.415 39.8357C261.344 40.1813 261.378 40.5401 261.512 40.8663C261.646 41.1926 261.874 41.4714 262.168 41.6673C262.461 41.8632 262.806 41.9673 263.159 41.9662C263.39 41.97 263.619 41.9279 263.834 41.8422C264.048 41.7564 264.243 41.6289 264.408 41.4669C264.573 41.305 264.704 41.1118 264.793 40.8988C264.882 40.6858 264.928 40.4571 264.928 40.2262Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.259 40.2262C272.265 39.8751 272.166 39.5303 271.975 39.2356C271.784 38.9409 271.51 38.7097 271.187 38.5713C270.865 38.433 270.508 38.3938 270.163 38.4587C269.818 38.5237 269.5 38.6898 269.25 38.936C269 39.1822 268.828 39.4974 268.758 39.8413C268.687 40.1852 268.72 40.5424 268.853 40.8673C268.986 41.1922 269.213 41.4702 269.504 41.6659C269.796 41.8616 270.139 41.9661 270.49 41.9662C270.721 41.97 270.951 41.9279 271.165 41.8422C271.379 41.7564 271.575 41.6289 271.739 41.4669C271.904 41.305 272.035 41.1118 272.124 40.8988C272.213 40.6858 272.259 40.4572 272.259 40.2262Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M279.591 40.2262C279.596 39.8751 279.497 39.5303 279.307 39.2356C279.116 38.9409 278.842 38.7097 278.519 38.5713C278.196 38.433 277.84 38.3938 277.495 38.4587C277.149 38.5237 276.832 38.6898 276.581 38.936C276.331 39.1822 276.16 39.4974 276.089 39.8413C276.018 40.1852 276.052 40.5424 276.185 40.8673C276.318 41.1922 276.544 41.4702 276.836 41.6659C277.127 41.8616 277.47 41.9661 277.821 41.9662C278.052 41.97 278.282 41.9279 278.496 41.8422C278.711 41.7564 278.906 41.6289 279.071 41.4669C279.235 41.305 279.366 41.1118 279.455 40.8988C279.545 40.6858 279.591 40.4572 279.591 40.2262Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M274.742 59.2154H83.8579V178.672H274.742V59.2154Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M269.869 64.1628H88.7239V173.713H269.869V64.1628Z",
    stroke: "#92E3A9",
    strokeWidth: 2.9,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M265.241 69.6438H93.3523V168.244H265.241V69.6438Z",
    stroke: "#92E3A9",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.552 81.18V82.195H149.357V81.1162C149.357 80.1012 148.957 79.4922 148.041 79.4922C147.124 79.4922 146.724 80.0722 146.724 81.1162V87.067C146.724 88.0762 147.142 88.691 148.041 88.691C148.94 88.691 149.357 88.0762 149.357 87.067V85.5996H150.552V86.98C150.552 88.6852 149.746 89.8104 148.006 89.8104C146.266 89.8104 145.483 88.6852 145.483 86.98V81.18C145.483 79.4748 146.289 78.3496 148.006 78.3496C149.723 78.3496 150.552 79.469 150.552 81.18Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.697 83.442V84.5672H152.942V88.5692H156.323V89.7292H151.683V78.454H156.323V79.614H152.942V83.4594L155.697 83.442Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.989 78.454C161.758 78.454 162.494 79.3588 162.494 81.0292V81.9456C162.494 83.1868 162.059 83.9582 161.096 84.2656C162.123 84.573 162.512 85.4256 162.512 86.6146V88.3546C162.475 88.8168 162.552 89.281 162.738 89.706H161.468C161.29 89.2751 161.218 88.8075 161.259 88.343V86.574C161.259 85.298 160.679 84.8978 159.617 84.8978H158.73V89.706H157.477V78.454H159.989ZM159.664 83.761C160.661 83.761 161.259 83.442 161.259 82.2182V81.1394C161.259 80.1302 160.888 79.5966 159.954 79.5966H158.73V83.761H159.664Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.452 89.7118V79.5966H163.382V78.4366H168.781V79.5966H166.711V89.7118H165.452Z",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M170.904 78.454V89.7118H169.651V78.454H170.904Z",
    fill: "#263238"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M176.037 83.6972V84.8572H173.445V89.7292H172.192V78.454H176.664V79.614H173.445V83.7146L176.037 83.6972Z",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.914 78.454V89.7118H177.655V78.454H178.914Z",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.166 81.18V82.195H183.96V81.1162C183.96 80.1012 183.56 79.4922 182.643 79.4922C181.727 79.4922 181.321 80.0722 181.321 81.1162V87.067C181.321 88.0762 181.739 88.691 182.643 88.691C183.548 88.691 183.96 88.0762 183.96 87.067V85.5996H185.149V86.98C185.149 88.6852 184.349 89.8104 182.609 89.8104C180.869 89.8104 180.086 88.6852 180.086 86.98V81.18C180.086 79.4748 180.886 78.3496 182.609 78.3496C184.331 78.3496 185.166 79.469 185.166 81.18Z",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.579 87.444L187.144 89.7118H185.984L188.136 78.454H189.951L192.109 89.7118H190.862L190.427 87.444H187.579ZM187.742 86.3652H190.247L188.977 79.8692L187.742 86.3652Z",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M194.736 89.7118V79.5966H192.66V78.4366H198.066V79.5966H195.989V89.7118H194.736Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M200.2 78.454V89.7118H198.947V78.454H200.2Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M201.36 81.18C201.36 79.44 202.212 78.3496 203.929 78.3496C205.646 78.3496 206.522 79.4574 206.522 81.18V86.98C206.522 88.6852 205.669 89.8104 203.929 89.8104C202.189 89.8104 201.36 88.72 201.36 86.98V81.18ZM202.595 87.067C202.595 88.0936 203.03 88.691 203.929 88.691C204.828 88.691 205.263 88.111 205.263 87.067V81.1104C205.263 80.0954 204.846 79.4864 203.929 79.4864C203.013 79.4864 202.595 80.0664 202.595 81.1104V87.067Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M208.836 89.7118H207.74V78.454H209.329L211.933 86.574V78.454H213.047V89.7118H211.742L208.842 80.6116L208.836 89.7118Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.125 95.9874H223.47",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M253.618 107.002H259.592",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.503 107.002H250.463",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M174.738 107.002H199.765",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.502 107.002H172.209",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.992 107.002H133.923",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.003 107.002H112.26",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M172.841 112.285H259.592",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.527 112.285H170.11",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M101.003 112.285H103.004",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M252.986 117.569H259.592",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M217.438 117.569H249.831",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.422 117.569H214.915",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M161.271 117.569H165.69",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.003 117.569H157.483",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M233.214 122.859H259.592",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M138.975 122.859H230.69",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.559 122.859H135.611",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.003 122.859H127.828",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M243.103 128.143H259.592",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M172.633 128.143H239.739",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M145.703 128.143H169.477",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M108.05 128.143H142.548",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M101.003 128.143H105.95",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M107.412 151.424L112.852 165.558L115.485 159.167L121.883 161.771L115.63 148.501L107.412 151.424Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M105.468 148.35L98.8855 161.986L105.347 159.544L107.823 165.988L113.229 152.352L105.468 148.35Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M121.865 144.916C121.865 144.4 122.985 143.808 122.915 143.31C122.845 142.811 121.604 142.55 121.459 142.068C121.314 141.587 122.219 140.694 122.01 140.236C121.801 139.777 120.537 139.882 120.27 139.453C120.003 139.023 120.612 137.921 120.27 137.539C119.928 137.156 118.756 137.614 118.374 137.278C117.991 136.941 118.281 135.717 117.852 135.439C117.422 135.161 116.425 135.938 115.955 135.723C115.485 135.509 115.427 134.25 114.934 134.105C114.441 133.96 113.71 134.987 113.194 134.917C112.678 134.847 112.272 133.653 111.756 133.653C111.24 133.653 110.816 134.847 110.317 134.917C109.819 134.987 109.065 133.966 108.577 134.105C108.09 134.244 107.997 135.514 107.551 135.723C107.104 135.932 106.089 135.143 105.66 135.439C105.231 135.735 105.521 136.947 105.138 137.283C104.755 137.62 103.572 137.156 103.241 137.539C102.911 137.921 103.526 139.023 103.241 139.453C102.957 139.882 101.704 139.772 101.501 140.236C101.298 140.7 102.197 141.575 102.052 142.068C101.907 142.561 100.672 142.805 100.597 143.31C100.521 143.814 101.646 144.4 101.646 144.916C101.646 145.432 100.527 146.018 100.597 146.517C100.666 147.016 101.907 147.277 102.052 147.764C102.197 148.251 101.287 149.133 101.501 149.591C101.716 150.049 102.975 149.951 103.241 150.374C103.508 150.797 102.893 151.905 103.241 152.288C103.589 152.671 104.749 152.213 105.138 152.549C105.527 152.885 105.231 154.109 105.66 154.388C106.089 154.666 107.087 153.889 107.551 154.103C108.015 154.318 108.084 155.577 108.577 155.722C109.07 155.867 109.801 154.84 110.317 154.915C110.834 154.991 111.24 156.174 111.756 156.174C112.272 156.174 112.695 154.985 113.194 154.915C113.693 154.846 114.447 155.861 114.934 155.722C115.421 155.582 115.514 154.312 115.961 154.103C116.407 153.895 117.422 154.683 117.852 154.388C118.281 154.092 117.991 152.88 118.374 152.549C118.756 152.218 119.94 152.671 120.27 152.288C120.601 151.905 119.986 150.803 120.27 150.374C120.554 149.945 121.807 150.055 122.01 149.591C122.213 149.127 121.314 148.251 121.459 147.758C121.604 147.265 122.84 147.027 122.915 146.517C122.99 146.007 121.865 145.432 121.865 144.916Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M111.768 151.911C115.631 151.911 118.762 148.779 118.762 144.916C118.762 141.053 115.631 137.921 111.768 137.921C107.904 137.921 104.773 141.053 104.773 144.916C104.773 148.779 107.904 151.911 111.768 151.911Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M111.767 140.108L112.846 143.431H116.338L113.513 145.479L114.592 148.802L111.767 146.749L108.943 148.802L110.022 145.479L107.197 143.431H110.689L111.767 140.108Z",
    fill: "#92E3A9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M130.095 141.564H156.775",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M130.095 147.938H156.775",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M244.68 156.696C250.158 156.696 254.598 152.256 254.598 146.778C254.598 141.3 250.158 136.86 244.68 136.86C239.203 136.86 234.762 141.3 234.762 146.778C234.762 152.256 239.203 156.696 244.68 156.696Z",
    stroke: "#92E3A9",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M246.116 153.364C249.746 152.57 252.044 148.983 251.249 145.353C250.455 141.723 246.868 139.425 243.238 140.22C239.608 141.014 237.31 144.601 238.105 148.231C238.9 151.861 242.486 154.159 246.116 153.364Z",
    fill: "#92E3A9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M277.34 258.37C277.34 258.37 275.31 254.89 274.295 253.005C273.587 251.641 272.957 250.237 272.41 248.8C272.41 248.8 274.875 250.25 275.6 250.83C276.325 251.41 279.37 255.035 279.37 255.035L280.24 254.02L279.225 250.685L282.56 254.455L284.155 247.64L286.62 254.165L291.26 248.365L291.55 254.165L297.205 249.67L295.175 256.775L293 259.82H277.485L277.34 258.37Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M276.47 258.37C276.47 258.37 275.165 257.79 272.99 255.18C271.601 253.489 270.341 251.695 269.22 249.815C269.22 249.815 274.15 252.57 275.89 253.875C277.375 255.144 278.734 256.552 279.95 258.08C279.95 258.08 278.5 254.455 278.355 252.715C278.21 250.975 278.065 247.205 278.065 247.205C278.065 247.205 282.27 251.41 282.56 252.57C282.85 253.73 284.445 257.645 284.445 257.645C284.926 255.878 285.313 254.088 285.605 252.28C285.895 250.105 288.215 246.625 288.215 246.625C288.215 246.625 288.505 249.09 288.65 251.555C288.795 254.02 287.345 258.66 287.345 258.66C287.345 258.66 289.23 254.165 291.115 251.99C292.595 250.374 294.194 248.871 295.9 247.495C295.9 247.495 294.45 251.99 293.87 254.02C293.328 255.6 292.598 257.109 291.695 258.515C293.056 256.795 294.508 255.149 296.045 253.585C297.46 252.453 298.963 251.434 300.54 250.54C300.54 250.54 298.945 253.585 297.785 255.325C296.703 256.835 295.541 258.287 294.305 259.675H276.47V258.37Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M296.886 258.08L295.882 266.925L294.16 282.051H275.988L274.266 266.925L273.262 258.08H296.886Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M295.882 266.925L294.16 282.051H275.988L274.266 266.925H295.882Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M277.63 271.13C278.11 271.13 278.5 270.74 278.5 270.26C278.5 269.78 278.11 269.39 277.63 269.39C277.15 269.39 276.76 269.78 276.76 270.26C276.76 270.74 277.15 271.13 277.63 271.13Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M284.01 271.13C284.49 271.13 284.88 270.74 284.88 270.26C284.88 269.78 284.49 269.39 284.01 269.39C283.529 269.39 283.14 269.78 283.14 270.26C283.14 270.74 283.529 271.13 284.01 271.13Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M280.095 275.625C280.575 275.625 280.965 275.235 280.965 274.755C280.965 274.275 280.575 273.885 280.095 273.885C279.614 273.885 279.225 274.275 279.225 274.755C279.225 275.235 279.614 275.625 280.095 275.625Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M287.78 275.625C288.26 275.625 288.65 275.235 288.65 274.755C288.65 274.275 288.26 273.885 287.78 273.885C287.299 273.885 286.91 274.275 286.91 274.755C286.91 275.235 287.299 275.625 287.78 275.625Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M292.855 275.625C293.335 275.625 293.725 275.235 293.725 274.755C293.725 274.275 293.335 273.885 292.855 273.885C292.374 273.885 291.985 274.275 291.985 274.755C291.985 275.235 292.374 275.625 292.855 275.625Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M290.39 271.13C290.871 271.13 291.26 270.74 291.26 270.26C291.26 269.78 290.871 269.39 290.39 269.39C289.91 269.39 289.52 269.78 289.52 270.26C289.52 270.74 289.91 271.13 290.39 271.13Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M277.63 279.25C278.11 279.25 278.5 278.86 278.5 278.38C278.5 277.9 278.11 277.51 277.63 277.51C277.15 277.51 276.76 277.9 276.76 278.38C276.76 278.86 277.15 279.25 277.63 279.25Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M284.01 279.25C284.49 279.25 284.88 278.86 284.88 278.38C284.88 277.9 284.49 277.51 284.01 277.51C283.529 277.51 283.14 277.9 283.14 278.38C283.14 278.86 283.529 279.25 284.01 279.25Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M290.39 279.25C290.871 279.25 291.26 278.86 291.26 278.38C291.26 277.9 290.871 277.51 290.39 277.51C289.91 277.51 289.52 277.9 289.52 278.38C289.52 278.86 289.91 279.25 290.39 279.25Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M189.284 184.05C189.295 179.629 186.959 176.04 184.067 176.033C181.174 176.026 178.82 179.604 178.81 184.024C178.799 188.445 181.135 192.034 184.027 192.041C186.92 192.048 189.274 188.47 189.284 184.05Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M190.624 163.998C190.624 163.998 187.8 165.616 185.109 163.865C182.417 162.113 184.302 161.313 184.842 160.234C185.381 159.155 184.036 158.888 183.763 157.409C183.49 155.93 184.436 154.718 184.975 154.585C185.515 154.451 185.381 152.967 185.381 151.488C185.381 150.009 187.121 148.663 187.933 148.663C188.745 148.663 189.279 147.59 189.818 146.244C190.358 144.899 191.436 143.687 193.298 144.504C195.16 145.322 196.123 145.311 197.068 143.965C198.014 142.619 200.293 142.353 201.128 143.025C201.963 143.698 202.335 145.044 203.953 143.698C205.571 142.353 207.584 142.625 208.523 143.565C209.463 144.504 209.329 145.583 210.843 145.044C212.357 144.504 214.741 145.311 215.28 146.929C215.82 148.547 218.76 150.293 219.856 149.887C220.953 149.481 222.814 149.887 221.869 151.905C220.924 153.924 222.008 155.269 222.814 155.269C223.621 155.269 225.372 155.809 224.427 157.554C223.481 159.3 222.814 160.652 223.887 161.185C224.96 161.719 226.712 161.858 225.372 164.149C224.032 166.44 222.948 166.301 223.354 167.629C223.76 168.957 224.56 169.369 223.354 170.32C222.147 171.271 220.663 171.666 220.663 172.472C220.663 173.278 222.275 173.678 220.39 174.351C219.303 174.748 218.174 175.02 217.026 175.163C217.026 175.163 214.341 167.896 206.667 165.477C198.994 163.059 194.563 163.32 192.811 164.265C191.059 165.21 190.624 163.998 190.624 163.998Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M193.333 213.321L183.473 217.869C183.473 217.869 178.375 246.091 178.74 253.921C179.106 261.751 183.473 281.234 183.473 281.234H207.16C207.16 281.234 203.518 257.378 205.339 248.823C207.16 240.268 211.533 216.778 211.533 216.778C211.533 216.778 204.249 214.777 202.062 214.412C199.875 214.046 193.333 213.321 193.333 213.321Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M182.023 226.505L209.283 228.86C209.063 230.02 208.842 231.18 208.616 232.34L181.472 230.02C181.64 228.79 181.843 227.613 182.023 226.505ZM205.351 248.8C205.559 247.814 205.803 246.631 206.07 245.32L179.587 243.035C179.436 244.253 179.303 245.43 179.181 246.55L205.351 248.817V248.8ZM207.671 237.072L180.706 234.752C180.532 235.912 180.358 237.072 180.196 238.267L206.986 240.587C207.236 239.462 207.462 238.29 207.694 237.096L207.671 237.072ZM178.758 251.712C178.723 252.547 178.717 253.283 178.758 253.898C178.758 254.322 178.81 254.78 178.85 255.261L204.84 256.92C204.84 255.679 204.84 254.484 204.84 253.37L178.758 251.712ZM183.641 217.77L183.479 217.845C183.479 217.845 183.247 219.145 182.899 221.262L210.252 223.628C210.495 222.311 210.721 221.128 210.907 220.148L183.641 217.77ZM205.681 269.634L181.06 269.373C181.292 270.602 181.53 271.791 181.756 272.922L206.116 273.201C206 272.087 205.849 270.892 205.722 269.68L205.681 269.634ZM180.005 263.787L205.275 265.272C205.175 264.085 205.088 262.896 205.014 261.705L179.43 260.203C179.639 261.38 179.836 262.587 180.045 263.81L180.005 263.787Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M191.877 208.2C191.877 208.2 189.876 215.844 189.696 219.852C189.516 223.86 193.698 227.131 199.707 226.586C205.716 226.041 206.806 219.487 206.806 217.845C206.806 216.204 207.16 202.4 207.16 202.4C205.146 204.124 203.014 205.705 200.78 207.133C197.341 209.314 191.877 208.2 191.877 208.2Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M197.341 214.777C203.031 212.051 205.867 206.698 207.149 203.299C207.149 202.719 207.149 202.394 207.149 202.394C205.134 204.118 203.002 205.699 200.769 207.127C197.289 209.314 191.848 208.223 191.848 208.223C191.848 208.223 190.601 213.002 189.986 216.981C192.543 216.66 195.029 215.915 197.341 214.777Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M216.84 178.991C216.84 178.991 216.608 170.918 213.61 166.301C210.611 161.684 204.289 158.859 197.231 160.06C188.473 161.568 184.54 168.134 183.154 173.673C181.768 179.212 183.386 187.285 183.386 192.813C183.386 198.34 189.847 208.27 191.692 209.888C193.536 211.506 196.384 212.04 199.638 210.392C202.625 208.873 207.537 203.705 210.536 200.706C213.534 197.708 215.321 188.787 215.785 186.711C216.249 184.635 216.84 178.991 216.84 178.991Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M192.376 194.674C192.376 194.674 192.103 196.414 196.14 196.153",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M191.164 199.245C191.164 199.245 195.873 202.475 200.583 199.384",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M200.583 188.48C200.583 188.48 201.789 186.462 205.293 188.207",
    stroke: "#263238",
    strokeWidth: 1.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M191.164 187.274C191.164 188.242 190.711 189.014 190.154 189.014C189.598 189.014 189.145 188.231 189.145 187.274C189.145 186.317 189.598 185.534 190.154 185.534C190.711 185.534 191.164 186.311 191.164 187.274Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M186.86 181.758C186.86 181.758 188.072 179.067 192.08 180.412",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M198.831 181.52C198.831 181.52 202.601 179.502 206.771 182.593",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M197.231 160.06C188.473 161.568 184.54 168.134 183.154 173.673C182.864 174.902 182.693 176.157 182.644 177.419C183.096 176.01 185.445 169.827 192.103 168.139C199.643 166.26 206.232 168.679 208.517 171.909C210.803 175.14 210.257 179.31 211.075 181.329C211.586 182.605 214.149 184.53 215.965 185.771C216.382 183.295 216.84 178.962 216.84 178.962C216.84 178.962 216.608 170.889 213.61 166.272C210.611 161.655 204.289 158.859 197.231 160.06Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M214.572 180.412C214.572 180.412 215.245 173.284 213.227 168.574C211.208 163.865 208.79 161.846 208.79 161.846C208.79 161.846 214.439 164.81 216.457 167.646C218.476 170.483 218.743 177.332 218.197 182.042L214.027 181.369L214.572 180.412Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M219.995 187.407C219.183 191.751 216.22 194.843 213.372 194.315C210.524 193.787 208.883 189.826 209.695 185.481C210.507 181.137 213.47 178.046 216.312 178.574C219.154 179.101 220.807 183.063 219.995 187.407Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M219.481 187.965C220.097 184.668 218.848 181.669 216.691 181.266C214.534 180.863 212.286 183.209 211.67 186.506C211.055 189.803 212.304 192.802 214.461 193.205C216.618 193.608 218.866 191.262 219.481 187.965Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M186.599 263.486C187.956 273.114 189.627 281.75 189.627 281.75H179.68C179.68 281.75 177.133 268.636 174.036 261.357C172.296 257.216 171.873 255.557 171.844 254.878C170.492 258.097 162.071 277.986 160.563 278.658C158.921 279.383 152.913 278.078 150.703 277.382C148.493 276.686 148.342 273.56 148.708 272.284C149.073 271.008 164.368 234.045 165.818 231.684C167.177 229.279 168.218 226.707 168.915 224.034C169.095 222.944 168.729 220.392 170.371 219.487C171.363 218.936 178.334 217.323 183.711 216.129C187.226 215.346 190.05 214.748 190.05 214.748C190.05 214.748 185.7 230.948 184.958 242.42C184.639 247.507 185.538 255.812 186.599 263.48C186.605 263.48 186.605 263.48 186.599 263.486Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M186.599 263.48C185.346 261.421 180.266 252.582 179.587 243.377C178.978 235.118 182.272 221.563 183.722 216.117C187.237 215.334 190.062 214.737 190.062 214.737C190.062 214.737 185.7 230.948 184.958 242.42C184.639 247.507 185.515 255.812 186.599 263.48Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M173.248 235.796C173.7 233.83 174.036 232.769 174.036 232.769",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M172.035 254.438C172.035 254.438 170.939 250.61 171.85 243.696C172.093 241.869 172.354 240.245 172.615 238.847",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M252.145 256.033C247.957 255.847 227.019 242.803 227.019 242.803C227.019 242.803 220.46 255.656 220.28 258.266C220.1 260.876 225.378 281.75 225.378 281.75H202.984C202.984 281.75 202.306 274.424 202.166 266.391C202.103 262.685 202.166 258.851 202.439 255.47C203.35 244.85 206.986 214.87 206.986 214.87L210.634 215.241C210.634 215.241 211.667 215.589 213.285 216.152C217.594 217.648 226.045 220.711 229.751 222.88C234.844 225.861 241.931 230.71 245.411 232.949C248.891 235.187 257.063 240.216 258.699 246.927C260.335 253.637 256.333 256.218 252.145 256.033Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M213.285 216.129C212.792 223.587 211.342 241.353 208.216 249.948C205.223 258.167 203.071 263.961 202.166 266.391C202.103 262.685 202.166 258.851 202.439 255.47C203.35 244.85 206.986 214.87 206.986 214.87L210.634 215.241C210.634 215.241 211.667 215.566 213.285 216.129Z",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M227.019 242.797L218.644 240.193",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M215.106 234.549C215.35 237.304 216.11 240.349 218.099 242.055",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M215.182 228.825C215.064 229.869 215.004 230.918 215.002 231.968",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M214.12 238.511C214.12 238.511 216.121 242.24 218.488 243.545",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M226.665 211.819C226.329 210.452 226.153 209.051 226.143 207.643C226.143 205.399 226.665 204.134 225.848 204.21C225.03 204.285 223.603 205.329 223.156 207.11C222.71 208.89 223.678 210.543 223.829 211.141C223.921 211.507 223.971 211.882 223.98 212.26C223.98 212.26 217.484 212.48 216.289 212.48C215.094 212.48 213.9 213.153 213.9 214.273C213.9 215.392 215.17 216.013 215.17 216.013L215.75 216.314C215.75 216.314 215.002 217.729 215.524 218.478C215.812 218.904 216.166 219.282 216.573 219.597C216.417 219.823 216.321 220.086 216.294 220.36C216.268 220.635 216.312 220.911 216.423 221.163C216.616 221.671 216.952 222.113 217.391 222.433C217.391 222.433 216.423 223.332 217.693 224.527C218.963 225.722 221.724 225.797 223.661 225.797C225.598 225.797 227.245 225.867 227.245 225.867L228.069 225.942L234.936 236.173L241.432 228.929C241.432 228.929 231.874 219.649 230.604 218.031C229.333 216.413 226.665 211.819 226.665 211.819Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M241.218 228.065L232.297 236.44C232.297 236.44 240.493 247.367 244.86 252.86C249.228 258.353 257.243 259.24 260.7 256.497C264.157 253.753 264.528 247.576 261.431 243.737C258.334 239.897 241.218 228.065 241.218 228.065Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M181.524 272.058C181.524 272.058 194.621 274.32 195.844 274.32C197.068 274.32 209.991 271.002 210.861 271.698C211.731 272.394 217.496 277.29 218.894 278.687C219.724 279.512 220.43 280.454 220.987 281.483H208.941L205.275 280.607C205.275 280.607 202.166 282.046 200.421 282.046C198.675 282.046 192.828 281.709 192.828 281.709L182.539 281.541C182.539 281.541 179.077 275.724 181.524 272.058Z",
    fill: "#B5B5B5",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M212.606 281.489C212.606 281.489 209.637 278.171 208.419 277.295C207.681 276.762 206.865 276.345 206 276.06",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M216.626 281.663C216.626 281.663 210.86 275.376 210.164 274.848C209.394 274.401 208.572 274.051 207.717 273.804",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M152.884 266.119C152.884 266.119 147.664 270.312 146.771 273.079C145.877 275.845 147.119 279.192 149.914 280.242C152.71 281.292 183.891 281.86 183.891 281.86C183.38 282.098 181.095 279.958 182.394 277.098C183.276 275.161 185.712 272.383 185.712 272.383L159.693 265.748",
    fill: "#92E3A9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M152.884 266.119C152.884 266.119 147.664 270.312 146.771 273.079C145.877 275.845 147.119 279.192 149.914 280.242C152.71 281.292 183.891 281.86 183.891 281.86C183.38 282.098 181.095 279.958 182.394 277.098C183.276 275.161 185.712 272.383 185.712 272.383L159.693 265.748",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M196.871 280.677H89.8606V282.051H196.871V280.677Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M158.051 282.051H91.3106L85.1394 235.64H151.88L158.051 282.051Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.694 282.051H89.9593L83.7881 235.64H150.523L156.694 282.051Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1155 282.051H156.491L151.851 247.019C143.638 252.239 133.633 258.996 122.729 267.319C114.418 273.747 105.083 278.728 95.1155 282.051Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M118.118 262.459C120.54 262.459 122.503 260.646 122.503 258.411C122.503 256.175 120.54 254.362 118.118 254.362C115.697 254.362 113.733 256.175 113.733 258.411C113.733 260.646 115.697 262.459 118.118 262.459Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4785 282.051H306.34",
    stroke: "#263238",
    strokeWidth: 0.58,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.a99b27ea198383e35551119c0f4acdc7.svg";
export { ForwardRef as ReactComponent };